import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

// POST /api/portal/mdf/requests/:id/resubmit — clone a declined request
// into a NEW draft. The original row stays untouched for audit trail.
//
// Returns the new draft id; the caller typically navigates the partner to
// /portal/mdf/drafts/:id to edit + resubmit.
//
// Attachments are reference-counted across drafts (the clone references
// the same storage_keys); see services/mdf.ts:cleanupOrphanStorageKey.
export function useResubmitMdf() {
  const queryClient = useQueryClient();
  return useMutation<{ id: string }, ApiClientError, { id: string }>({
    mutationFn: ({ id }) =>
      apiFetch<{ id: string }>(`/portal/mdf/requests/${id}/resubmit`, {
        method: "POST",
      }),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.mdf.requests() });
    },
    onError: (err) => {
      toast.error(err.message ?? "Failed to start a resubmission");
    },
  });
}
